module.exports = __webpack_public_path__ + "img/speech_bubble.bcaae574.png";